// extracted by mini-css-extract-plugin
module.exports = {"currentPageLink":"pager-module--currentPageLink--1kP3U","pageLink":"pager-module--pageLink--1eOCe","pager":"pager-module--pager--19glT"};